/**
 * Domain color palettes shared by every page that renders per-account or
 * per-cluster chips, so the same account keeps the same color across the
 * resources table, project compliance and project overview.
 */

/** Stable per-account dot colors (index = position in the accounts list). */
export const ACCOUNT_DOT_COLORS = [
  '#0d74ce',
  '#7c5cbf',
  '#0d8a4f',
  '#b45309',
  '#8a3a8a',
];

/** Cluster-type chip colors (EKS / AKS / K8S / GKE). */
export const CLUSTER_CHIP_COLORS: Record<string, string> = {
  EKS: '#1f5493',
  AKS: '#0d74ce',
  K8S: '#7c5cbf',
  GKE: '#34a853',
};

/**
 * Rule severity palette (legacy hexes kept for the resources-table pills
 * and drawers; token-styled pages map severities to BUI tones instead).
 */
export const SEVERITY_COLORS: Record<string, string> = {
  Critical: '#e61e1e',
  High: '#f0963c',
  Medium: '#e6dc3c',
  Low: '#829182',
};

/**
 * Foreground for a severity pill: the Medium yellow fails contrast with
 * white text, so it renders dark instead.
 */
export const severityForeground = (severity: string): string =>
  severity.toLowerCase() === 'medium' ? '#3d3500' : '#ffffff';

/** Dot color for the Nth account, falling back to the last palette entry. */
export const accountDotColor = (index: number): string =>
  ACCOUNT_DOT_COLORS[index % ACCOUNT_DOT_COLORS.length];
